import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M3 5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3h-1.224a4 4 0 0 0-2.828 1.172L9 14.119A4 4 0 0 0 7.97 18H5a2 2 0 0 1-2-2z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.128 18q.12.193.286.362l2.225 2.224a2 2 0 0 0 2.828 0l4.947-4.948A2 2 0 0 0 21 14.224V11a1 1 0 0 0-1-1h-3.224a2 2 0 0 0-1.414.586l-4.948 4.947A2 2 0 0 0 10.127 18M19 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
      clipRule: "evenodd"
    }
  )
);
var SvgTagsAndNotesFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TagsAndNotesFilled_default = SvgTagsAndNotesFilled;

export { TagsAndNotesFilled_default as default };
